import { css } from 'aphrodite';
import { Field, FormProps, reduxForm, SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import * as React from 'react';
import * as cookie from 'react-cookie';

import { animationStyles, paneFormStyles } from 'login-components/Common/PaneLayout/paneStyles';
import { requestDormancyReset } from 'login-apis/accountRequestAPI';
import * as formUtils from 'login-utils/formUtils';
import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import InputMap from 'login-components/Common/Inputs/InputMap';
import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';

const FORM_ERROR_ID = 'RequestDormancyResetForm-formError';
const input: FormInput = {
  ...InputMap.EmailInput,
  name: 'email',
  identifier: 'email',
  label: 'Email',
};

type RequestDormancyResetProps = FormProps<any, any, any>;

interface RequestDormancyResetState {
  submitSuccess: boolean;
  successText?: string | null;
}

export class RequestDormancyReset extends React.Component<RequestDormancyResetProps, RequestDormancyResetState> {
  constructor(props) {
    super(props);
    this.state = {
      successText: null,
      submitSuccess: false,
    };
  }

  submitDormancyReset = async values => {
    this.setState({
      submitSuccess: false,
    });
    try {
      await requestDormancyReset(values);
      this.setState({
        successText: 'Sent! Check your email.',
        submitSuccess: true,
      });
    } catch (err) {
      this.setState({
        successText: null,
        submitSuccess: false,
      });

      const responseData = _.get(err, 'response.data'); // might be an object or undefined
      const errorText = _.isString(responseData) ? responseData : 'There was an error requesting the dormancy reset.';

      throw new SubmissionError({ _error: errorText });
    }
  };

  render() {
    const { error, handleSubmit, submitting } = this.props;
    const { submitSuccess, successText } = this.state;
    const btnText = submitSuccess || submitting ? 'Resend' : 'Send link';

    return (
      <form
        className={`${css(paneFormStyles.container)} RequestDormancyReset`}
        noValidate
        onSubmit={handleSubmit!(this.submitDormancyReset)}
      >
        <div>
          <fieldset className={css(paneFormStyles.fieldWrapper)}>
            <Field key={input.name} {...input} hidePlaceholder={true} />
          </fieldset>
          {error && (
            <div className={css(paneFormStyles.errorWrapper)}>
              <ErrorMessage errorText={error} errorId={FORM_ERROR_ID} />
            </div>
          )}
        </div>
        <div
          data-it="RequestDormancyReset-successText"
          className={css(paneFormStyles.successText, submitSuccess && animationStyles.slideandFade)}
        >
          {successText}
        </div>
        <div className={css(paneFormStyles.buttonDisplay, paneFormStyles.buttonPadding)}>
          <PrimaryButton isWide={true} disabled={submitting} buttonId="it-RequestDormancyResetSubmit" text={btnText} />
        </div>
      </form>
    );
  }
}

const FormConnectedRequestDormancyReset = reduxForm({
  form: 'dormancyReset',
  validate: _.partial(formUtils.validate, [input]) as any,
  onSubmitFail: syncErrors => formUtils.focusOnSubmitFail(syncErrors, FORM_ERROR_ID),
})(RequestDormancyReset);

const mapStateToProps = state => ({
  initialValues: {
    email: decodeURIComponent(cookie.load('email') || ''),
  },
});
const ConnectedRequestDormancyReset = connect(mapStateToProps)(FormConnectedRequestDormancyReset as any);

export default ConnectedRequestDormancyReset;
